module.exports = __webpack_public_path__ + "static/media/canvasClose.2fc1cdd4.svg";